import { createContext, useContext } from "react";
import UserContext from "./UserContext";

/**
 * The CT track (ctGrade: 2, 3, 4, 5, 6 or 9) the backend assigned to the current
 * CT activity. CT screens show content for this track; it can differ from the
 * student's grade (reading-level placement, promotion to the next track).
 * Provided by pages/Critical.js from the /critical/init response.
 */
const CtTrackContext = createContext(null);

/** The grade CT screens should use: the track if the backend sent one, else user.grade. */
export function useCtGrade() {
    const track = useContext(CtTrackContext);
    const { user } = useContext(UserContext);
    return track ?? user?.grade;
}

export default CtTrackContext;
